import React from "react";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "src/ui/shared/CustomButton";

import { AddDeviceModal } from "@dashboard/devices/components/Table/AddDeviceModal/AddDeviceModal";
import { useAddDevice } from "@dashboard/devices/components/Table/AddDeviceModal/useAddDevice";
import { EmptyState } from "@shared/EmptyState/EmptyState";
import emptyOverviewImage from "@shared/images/EmptyOverview.webp";

export const EnrollFirstDeviceSection = () => {
    const { t } = useTranslation(["pages", "common"]);
    const { addDevice, modalProps: addDeviceModalProps } = useAddDevice();

    return (
        <>
            <EmptyState
                framed
                image={emptyOverviewImage}
                title={t("pages:overviewPage.enrollFirstDevice.title")}
                description={t("pages:overviewPage.enrollFirstDevice.message")}
                action={
                    <PrimaryButton onClick={addDevice} name="enroll-first-device">
                        {t("common:button.enrollFirstDevice")}
                    </PrimaryButton>
                }
            />
            <AddDeviceModal {...addDeviceModalProps} />
        </>
    );
};
